import React from 'react';
import { AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, ReferenceLine } from 'recharts';
import { Card } from 'react-bootstrap';
import { formatCurrency } from '../../shared/utils/currency';

// Groups the same monthly asset/debt records the other Asset charts use
// into a single net-worth-per-month series (assets positive, debts
// already negative, so a plain sum per month is the net worth).
export const computeNetWorthByMonth = (data) => {
  const totals = new Map();
  (data || []).forEach(({ YearMonth, total_value }) => {
    totals.set(YearMonth, (totals.get(YearMonth) || 0) + total_value);
  });
  return Array.from(totals.entries())
    .map(([YearMonth, netWorth]) => ({ YearMonth, netWorth }))
    .sort((a, b) => a.YearMonth.localeCompare(b.YearMonth));
};

const CustomTooltip = ({ active, payload, label, currency }) => {
  if (active && payload && payload.length) {
    return (
      <div className="custom-tooltip card p-2">
        <p className="label mb-1">{`Month: ${label}`}</p>
        <p className="mb-0" style={{ color: payload[0].stroke, fontWeight: 'bold' }}>
          {`Net Worth: ${formatCurrency(payload[0].value, currency)}`}
        </p>
      </div>
    );
  }
  return null;
};

const NetWorthTrendChart = ({ data, currency }) => {
  const chartData = computeNetWorthByMonth(data);

  if (chartData.length === 0) {
    return (
      <Card className="mb-4 shadow-lg">
        <Card.Header>Net Worth Trend</Card.Header>
        <Card.Body>
          <p>No asset data available for charting.</p>
        </Card.Body>
      </Card>
    );
  }

  return (
    <Card className="mb-4 shadow-lg">
      <Card.Header>Net Worth Trend</Card.Header>
      <Card.Body style={{ height: '350px' }}>
        <ResponsiveContainer width="100%" height="100%">
          <AreaChart data={chartData} margin={{ top: 20, right: 30, left: 20, bottom: 5 }}>
            <defs>
              <linearGradient id="netWorthGradient" x1="0" y1="0" x2="0" y2="1">
                <stop offset="5%" stopColor="#7c3aed" stopOpacity={0.55} />
                <stop offset="50%" stopColor="#4a90e2" stopOpacity={0.25} />
                <stop offset="100%" stopColor="#4a90e2" stopOpacity={0.02} />
              </linearGradient>
            </defs>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="YearMonth" />
            <YAxis tickFormatter={(value) => formatCurrency(value, currency)} width={90} />
            <Tooltip content={<CustomTooltip currency={currency} />} />
            <ReferenceLine y={0} stroke="#888" />
            <Area
              type="monotone"
              dataKey="netWorth"
              name="Net Worth"
              stroke="#7c3aed"
              strokeWidth={3}
              fill="url(#netWorthGradient)"
              dot={{ r: 3, stroke: '#7c3aed', strokeWidth: 2, fill: '#fff' }}
              activeDot={{ r: 7, stroke: '#7c3aed', strokeWidth: 2, fill: '#ff7300' }}
            />
          </AreaChart>
        </ResponsiveContainer>
      </Card.Body>
    </Card>
  );
};

export default NetWorthTrendChart;
